'use strict';

/**
 * @classname ChangeItemDetailImage
 * @classdesc メイン画像変更
 */
export default class ChangeItemDetailImage {
	/**
	 * @constructor
	 * @param {jQuery} $e - .image-box--thumb .image
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof ChangeItemDetailImage
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		const src = this._$e.attr('src');
		const srcArray = src.split('/');
		const srcLength = srcArray.length;
		const fileName = `l-${srcArray[srcLength - 1]}`;
		let newPath = '';
		for(let i = 0; i < srcLength - 1; i++) {
			newPath += srcArray[i];
			newPath += '/';
		}
		newPath = newPath + fileName;
		console.log(newPath);
		$('.image-box--main .image').attr('src', newPath);
	};
};
